import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Map } from 'immutable';

import { AddOns as AddOnsModel } from 'models/addons';
import { Location } from 'models/locations';

import BrandName from 'containers/common/brand-name';
import ClearCouponCode from 'containers/checkout/review-and-confirm/clear-coupon-code';
import CurrencySymbol from 'components/common/currency-symbol';


const propTypes = {
  location: PropTypes.instanceOf(Location).isRequired,
  type: PropTypes.string,
  subTotal: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  couponCode: PropTypes.string,
  couponAmount: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  userCreditAmount: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  selectedAddOns: PropTypes.oneOfType([
    PropTypes.instanceOf(AddOnsModel),
    PropTypes.instanceOf(Map),
  ]),
  expandable: PropTypes.bool,
};

const defaultProps = {
  type: null,
  couponCode: null,
  couponAmount: 0,
  userCreditAmount: 0,
  selectedAddOns: null,
  expandable: false,
  subTotal: 0,
};

class LineItems extends Component {
  constructor(props) {
    super(props);

    this.toggleDisplay = this.toggleDisplay.bind(this);
  }

  componentWillMount() {
    this.setState({
      show: false,
    });
  }

  toggleDisplay(e) {
    e.preventDefault();
    this.setState({
      show: !this.state.show,
    });
  }

  lineItemsPresent() {
    const { couponCode, couponAmount, userCreditAmount, selectedAddOns } = this.props;
    return (couponCode
      || parseInt(couponAmount, 10)
      || parseInt(userCreditAmount, 10)
      || (selectedAddOns && selectedAddOns.totalCount)
    );
  }

  renderSubTotalLineItem() {
    const { location, subTotal, type } = this.props;

    if (!(type === 'receipt' || this.lineItemsPresent())) { return null; }

    return (
      <div className="row order-line-item">
        <div className="col-xs-8 order-line-item-description">
          Parking Cost
        </div>
        <div className="col-xs-4 order-line-item-amount text-align-xs-right">
          <CurrencySymbol location={location} />
          { Number(subTotal).toFixed(2) }
        </div>
      </div>
    );
  }

  renderCreditLineItem() {
    const { location, userCreditAmount } = this.props;

    return (
      <div className="row order-line-item">
        <div className="col-xs-8 order-line-item-description">
          <BrandName /> Credits
        </div>
        <div className="col-xs-4 order-line-item-amount text-align-xs-right">
          -
          <CurrencySymbol location={location} />
          { Number(userCreditAmount).toFixed(2) }
        </div>
      </div>
    );
  }

  renderAddonLineItems() {
    const { location, selectedAddOns, type } = this.props;
    const renderedSelectedAddons = [];

    Map(Object.entries((selectedAddOns || Map()).toJSON())).forEach((addOns, addOnType) => {
      let i = 1;
      if (addOns) {
        addOns.forEach((addOn) => {
          const name = addOn.name.charAt(0).toUpperCase() + addOn.name.slice(1).toLowerCase();
          const key = [addOnType, (addOn.id || i)];
          i += 1;

          renderedSelectedAddons.push(
            <div className="row order-line-item" key={key}>
              <div className="col-xs-8 order-line-item-description">
                { name }
              </div>
              <div className="col-xs-4 order-line-item-amount text-align-xs-right">
                { type === 'receipt' ? null : '+' }
                <CurrencySymbol location={location} />
                { Number(addOn.price).toFixed(2) }
              </div>
            </div>,
          );
        });
      }
    });

    return renderedSelectedAddons;
  }

  renderCouponLineItem() {
    const { couponAmount, couponCode, location, type } = this.props;

    const couponAndRemove = (
      <div>
        <strong className="uppercase">{ couponCode }</strong>
        { type === 'receipt' ? null : <ClearCouponCode /> }
      </div>
    );

    return (
      <div>
        <hr />
        <div className="row coupon order-line-item">
          <div className="col-xs-8 order-line-item-description">
            Promo Code
          </div>
          <div className="col-xs-4 order-line-item-amount text-align-xs-right">
            -
            <CurrencySymbol location={location} />
            { Number(couponAmount).toFixed(2) }
          </div>
          <div className="col-xs-12 order-line-item-description">
            { couponCode ? couponAndRemove : null }
          </div>
        </div>
      </div>
    );
  }

  renderExpandLink() {
    if (!this.lineItemsPresent()) { return null; }
    let text;
    if (this.state && this.state.show) {
      text = '- Hide Details';
    } else if (this.state) {
      text = '+ Expand Details';
    }
    return (
      <p className="toggle-line-items">
        <a href="#" onClick={this.toggleDisplay}>{text}</a>
      </p>
    );
  }

  render() {
    const lineItemsClasses = cx({
      'line-items': true,
      'hidden': this.props.expandable && !this.state.show,
    });

    return (
      <div className="line-items-container">
        <div className={lineItemsClasses}>
          {this.renderSubTotalLineItem()}
          {this.renderAddonLineItems()}
          {this.props.userCreditAmount > 0 ? this.renderCreditLineItem() : null}
          {this.props.couponAmount > 0 ? this.renderCouponLineItem() : null}
        </div>
        {this.props.expandable ? this.renderExpandLink() : null}
      </div>
    );
  }
}

LineItems.propTypes = propTypes;
LineItems.defaultProps = defaultProps;

export default LineItems;
